import PromoBannerOfferToggle from '../../../../components/PromoBannerOfferToggle/PromoBannerOfferToggle';
import PromobannerName from '../../../../components/PromobannerName/PromobannerName';
import { PromobannerTarget } from '../../../../components/PromobannerTarget/PromobannnerTarget';
import PromobannerUpload from '../../../../components/PromobannerUpload/PromobannerUpload';
import PromobannerValidity from '../../../../components/PromobannerValidity/PromobannerValidity';

const PromoBannerCreateContent = (): JSX.Element | null => {
  return (
    <>
      <PromobannerUpload />
      <div className="promobanner-row">
        <PromobannerName />
        <PromobannerValidity />
        <PromoBannerOfferToggle />
      </div>
      <PromobannerTarget />
    </>
  );
};

export default PromoBannerCreateContent;
